import dataMaps from './dataMaps';

let topo = function(x, y) {
  return dataMaps.surf.getData(x, y);
};
topo.units = dataMaps.surf.units;

let gpr = function(x, y, direction) {
  if (direction === 'n') {
    return dataMaps.gpr_v.getData(x, y);
  } else if (direction === 'e') {
    return dataMaps.gpr_h.getData(x, y);
  } else if (direction === 's') {
    return dataMaps.gpr_v.getData(x, y - 1);
  } else if (direction === 'w') {
    return dataMaps.gpr_h.getData(x - 1, y);
  }
  return null;
};

let mmd = function(x, y) {
  return dataMaps.mmd.getData(x, y);
};

let srr = function(x, y) {
  return dataMaps.srr.getData(x, y);
};
srr.units = dataMaps.srr.units;

let drill = function(x, y, elevation) {
  let result = {};
  result.surface = dataMaps.surf.getData(x, y);
  result.waterTable = dataMaps.water.getData(x, y);
  result.floatingGasThickness = dataMaps.floatgas.getData(x, y);
  if (!result.floatingGasThickness /* === null*/) {
    result.floatingGasThickness = 0;
  }
  result.bedrock = dataMaps.srr.getData(x, y);

  return result;
};
drill.units = {
  waterTable: 'ft',
  floatGas: 'ft',
  bedrock: 'ft',
};

let sampleAnalysis = function(x, y, elevation, analysis) {
  if (analysis === 'gw_hydrocarbons') {
    let map = dataMaps['gas' + elevation];
    if (typeof map === 'undefined') {
      return {
        xylene: 0,
        toluene: 0,
        benzene: 0,
        ethylBenzene: 0,
      };
    }
    var gas = map.getData(x, y);
    return {
      xylene: gas,
      toluene: Math.round(gas / 1.6),
      benzene: Math.round(gas / 3.5),
      ethylBenzene: Math.round(gas / 7.2),
    };
  } else if (analysis === 'gw_tritium') {
    let map = dataMaps['tritium' + elevation];
    if (typeof map === 'undefined') {
      return {
        tritium: 0,
      };
    }
    return {
      tritium: map.getData(x, y),
    };
  }

  return null;
};
sampleAnalysis.units = {
  tritium: { tritium: 'Ci/l' },
  hydroCardbons: {
    xylene: 'ppb',
    toluene: 'ppb',
    benzene: 'ppb',
    ethylBenzene: 'ppb',
  },
};

let sgsa = function(x, y) {
  return dataMaps.sgsa.getData(x, y);
};
sgsa.units = dataMaps.sgsa.units;

let exca = function(x, y) {
  return dataMaps.exca.getData(x, y);
};
let loess = function(x, y) {
  return dataMaps.loess.getData(x, y);
};

export default {
  topo,
  gpr,
  mmd,
  srr,
  drill,
  sampleAnalysis,
  sgsa,
  exca,
  loess,
};
